var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7929 0.999925C11.1834 0.609401 11.8166 0.609399 12.2071 0.999925L14 2.79282C14.3905 3.18334 14.3905 3.81651 14 4.20703L3.5 14.707C3.31246 14.8946 3.05811 14.9999 2.79289 14.9999H1C0.447715 14.9999 0 14.5522 0 13.9999V12.207C0 11.9418 0.105357 11.6875 0.292893 11.4999L5.54289 6.24992L10.7929 0.999925ZM9.70711 3.49992L11.5 5.29282L13.2929 3.49992L11.5 1.70703L9.70711 3.49992ZM10.7929 5.99992L9 4.20703L1 12.207V13.9999H2.79289L10.7929 5.99992Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.ee77bdd07459601b253423173b3778e6.svg";
export { ForwardRef as ReactComponent };